"use strict";
/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
import * as i0 from "@angular/core";
import * as i1 from "./navigation-performance-tracking.component";
import * as i2 from "./tracking.service";
import * as i3 from "./tracking.config";
var styles_NavigationPerformanceTrackingComponent = [];
var RenderType_NavigationPerformanceTrackingComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_NavigationPerformanceTrackingComponent, data: {} });
export { RenderType_NavigationPerformanceTrackingComponent as RenderType_NavigationPerformanceTrackingComponent };
export function View_NavigationPerformanceTrackingComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, null, null, null, null, null, null, null))], null, null); }
export function View_NavigationPerformanceTrackingComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fl-navigation-performance-tracking", [], null, null, null, View_NavigationPerformanceTrackingComponent_0, RenderType_NavigationPerformanceTrackingComponent)), i0.ɵdid(1, 114688, null, 0, i1.NavigationPerformanceTrackingComponent, [i2.Tracking, i3.TRACKING_CONFIG], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var NavigationPerformanceTrackingComponentNgFactory = i0.ɵccf("fl-navigation-performance-tracking", i1.NavigationPerformanceTrackingComponent, View_NavigationPerformanceTrackingComponent_Host_0, {}, {}, []);
export { NavigationPerformanceTrackingComponentNgFactory as NavigationPerformanceTrackingComponentNgFactory };



// WEBPACK FOOTER //
// navigation-performance-tracking.component.ngfactory.js